import {
  fetch as apiFetch,
  postData,
  putData,
  deleteFunction,
} from "../../Component/function/FunctionApi";

// =========================================================
// Endpoint
// =========================================================

const EXPENSES_ENDPOINT = "RepresentativeSettlement/expenses";

// =========================================================
// GET - جلب كل المصروفات
// GET /api/RepresentativeSettlement/expenses
// =========================================================


export const getExpenses = async (selectedDate) => {
  const fromDate = `${selectedDate}T00:00:00`;
  const toDate = `${selectedDate}T23:59:59`;

  const query = new URLSearchParams({
    Date: fromDate,
    FromDate: fromDate,
    ToDate: toDate,
  });

  const response = await apiFetch(
    `${EXPENSES_ENDPOINT}?${query.toString()}`
  );

  return response;
};

// =========================================================
// POST - إضافة مصروف
// POST /api/RepresentativeSettlement/expenses
// =========================================================

export const createExpense = async (payload, setError = () => {}) => {
  const response = await postData(
    EXPENSES_ENDPOINT,
    payload,
    setError
  );

  return response?.data;
};

// =========================================================
// PUT - تعديل مصروف
// PUT /api/RepresentativeSettlement/expenses/{id}
// =========================================================

export const updateExpense = async (
  id,
  payload,
  setError = () => {}
) => {
  const response = await putData(
    `${EXPENSES_ENDPOINT}/${id}`,
    payload,
    setError
  );

  return response?.data;
};

// =========================================================
// DELETE - حذف مصروف
// DELETE /api/RepresentativeSettlement/expenses/{id}
// =========================================================

export const deleteExpense = async (id) => {
  const response = await deleteFunction(
    `${EXPENSES_ENDPOINT}/${id}`
  );

  return response?.data;
};

const DAILY_PAYMENTS_ENDPOINT =
  "Represntative/daily-payments";

// =========================================================
// GET
// /api/Represntative/daily-payments
// ?dateDaily=2026-09-26T00:00:00
// =========================================================

export const getDailyPayments = async (
  dateDaily
) => {
  const queryDate = `${dateDaily}T00:00:00`;

  const response = await apiFetch(
    `${DAILY_PAYMENTS_ENDPOINT}?dateDaily=${encodeURIComponent(
      queryDate
    )}`
  );

  return response;
};

// =========================================================
// Daily Safe Summary
// =========================================================

const DAILY_SAFE_SUMMARY_ENDPOINT =
  "Represntative/daily-safe-summary";

export const getDailySafeSummary = async (
  selectedDate
) => {
  const fromDate = `${selectedDate}T00:00:00`;

  const toDate = `${selectedDate}T23:59:59`;

  const params = new URLSearchParams({
    Date: fromDate,
    FromDate: fromDate,
    ToDate: toDate,
    dateDaily: fromDate,
  });

  const response = await apiFetch(
    `${DAILY_SAFE_SUMMARY_ENDPOINT}?${params.toString()}`
  );

  return response;
};;